<template>
  <div class="flex flex-row items-center gap-3">
    <p
      v-if="originalRequestStockableIds.length > 1"
      class="text-sm text-gray-500"
    >
      {{
        $t('global.item_index_of_total', {
          index: currentStockableIndex + 1,
          total: originalRequestStockableIds.length
        })
      }}
    </p>
    <div
      class="divide-x divide-slate-200 overflow-hidden rounded-md border border-slate-300"
    >
      <button
        v-if="originalRequest?.length > max_button_page"
        class="px-3 py-2 disabled:cursor-not-allowed disabled:bg-gray-100"
        :disabled="!previousPageAvailable"
        @click="previousPage"
      >
        <FontAwesomeIcon :icon="['fal', 'chevron-left']" />
      </button>
      <ItemsPaginationButton
        v-for="(id, idx) in originalRequestStockableIds"
        :key="id"
        :value="idx + 1"
        :original-item="originalRequest[id]"
        :parent-item-name="parentItemNameOf(originalRequest[id])"
        :selected="page === id"
        @click="setCurrentPage(id)"
      />
      <button
        v-if="originalRequest?.length > max_button_page"
        class="px-3 py-2 disabled:cursor-not-allowed disabled:bg-gray-100"
        :disabled="!nextPageAvailable"
        @click="nextPage"
      >
        <FontAwesomeIcon :icon="['fal', 'chevron-right']" />
      </button>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ItemsPaginationButton from '@c/Stock/Component/ItemsPaginationButton.vue'
import { getStockablePageIndexes } from '@u/helpers/stockOriginalHelpers'

export default {
  name: 'ItemsPagination',
  components: { ItemsPaginationButton, FontAwesomeIcon },
  props: {
    page: {
      type: Number,
      required: true
    },
    originalRequest: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['update:page'],
  data() {
    return {
      max_button_page: 5
    }
  },
  computed: {
    localPage: {
      get() {
        return this.page
      },
      set(value) {
        this.$emit('update:page', value)
      }
    },
    originalRequestStockableIds() {
      return getStockablePageIndexes(this.originalRequest)
    },
    currentStockableIndex() {
      return this.originalRequestStockableIds.indexOf(this.page)
    },
    itemNameByEntryId() {
      const map = {}
      ;(this.originalRequest ?? []).forEach((entry) => {
        if (entry?.id) map[entry.id] = entry.item?.item_name ?? entry.item_name
      })
      return map
    },
    nextPageAvailable() {
      return (
        this.currentStockableIndex < this.originalRequestStockableIds.length - 1
      )
    },
    previousPageAvailable() {
      return this.currentStockableIndex > 0
    }
  },
  methods: {
    parentItemNameOf(entry) {
      if (!entry?.component_parent_id) return entry?.parent_item_name ?? null
      return (
        this.itemNameByEntryId[entry.component_parent_id] ??
        entry.parent_item_name ??
        null
      )
    },
    nextPage() {
      if (!this.nextPageAvailable) {
        return
      }
      this.localPage =
        this.originalRequestStockableIds[this.currentStockableIndex + 1]
    },
    previousPage() {
      if (!this.previousPageAvailable) {
        return
      }
      this.localPage =
        this.originalRequestStockableIds[this.currentStockableIndex - 1]
    },
    setCurrentPage(id) {
      this.localPage = id
    }
  }
}
</script>
